module.exports = __webpack_public_path__ + "img/logo-alquimia.61906771.png";